import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import * as Editor from 'wangeditor/release/wangEditor.js';
import { NzNotificationService } from '../notification';

@Component({
  selector: 'nz-rich-text-editor',
  preserveWhitespaces: false,
  templateUrl: './rich-text-editor.component.html'
})
export class NzRichTextEditorNetComponent implements OnInit, OnChanges {

  @Input('id') editorId = `edite`;
  @Input('value') value: string = '';
  @Input('valueType') valueType: string = 'html';
  @Input('changeInterval') changeInterval: number = 200;
  @Input('cache') cache: boolean = true;
  @Input('cacheId') cacheId: string = 'edite';

  @Input('imgBase64') imgBase64: boolean = false;
  // æ¯å¦ä½¿ç¨ base64 ä¿å­å¾ç

  @Input('imgUploadUrl') imgUploadUrl: string = '';
  // å¾çä¸ä¼ æå¡ç«¯å°å

  @Input('uploadOptions') uploadOptions: {
  // å¾çä¸ä¼ æå¡ç«¯éç½®éé¡¹

    uploadImgMaxSize: number,
    // éå¶ä¸ä¼ å¾çå¤§å°

    uploadImgMaxLength: number,
    // éå¶ä¸æ¬¡æå¤ä¸ä¼ å¾çå¼ æ°

    uploadImgParams: any,
    // ä¸ä¼ å¾çæ¶å¯èªå®ä¹ä¼ éä¸äºåæ°

    uploadImgParamsWithUrl: boolean,
    // æ¯å¦å°åæ°æ¼æ¥å° url ä¸­

    uploadImgTimeout: number,
    // è¶æ¶æ¶é´ï¼é»è®¤ç timeout æ¶é´æ¯ 10 ç§é

    withCredentials: boolean,
    // è·¨åä¸ä¼ ä¸­å¦æéè¦ä¼ é cookie éè®¾ç½® withCredentials

    customAlert: Function,
    // ä¸ä¼ å¾ççéè¯¯æç¤º é»è®¤ä½¿ç¨createNotificationå¼¹åºï¼è¿éå¯ä»¥èªå®ä¹ç¨æ·ä½éªæ´å¥½çæç¤ºæ¹å¼

  } = {
    uploadImgMaxSize: 3 * 1024 * 1024,
    uploadImgMaxLength: 1000,
    uploadImgParams: {},
    uploadImgParamsWithUrl: true,
    uploadImgTimeout: 3000,
    withCredentials: true,
    customAlert: (info) => {
      // info æ¯éè¦æç¤ºçåå®¹
      this.createNotification('error', 'åå¦ï¼åºç°äºä¸ç¹é®é¢', info);
    }
  }
  @Output('oninput') input: EventEmitter<any> = new EventEmitter();
  @Output('onchange') onchange: EventEmitter<any> = new EventEmitter();

  public editor;

  constructor(private notification: NzNotificationService) {
  }

  ngOnInit() {
    this.editor = new Editor(`#${this.editorId}`)
    this.editor.customConfig.onchange = (html) => {
      let text = this.editor.txt.text();
      if (this.cache) localStorage[`editorCache_${this.cacheId}`] = html;
      this.input.emit(this.valueType === 'html' ? html : text);
      this.onchange.emit({html, text});
    }
    this.editor.customConfig.uploadImgShowBase64 = this.imgBase64;
    this.editor.customConfig.uploadImgServer = this.imgUploadUrl;
    this.editor.customConfig.uploadImgMaxSize = this.uploadOptions.uploadImgMaxSize;
    this.editor.customConfig.uploadImgMaxLength = this.uploadOptions.uploadImgMaxLength;
    this.editor.customConfig.uploadImgParams = this.uploadOptions.uploadImgParams;
    this.editor.customConfig.uploadImgParamsWithUrl = this.uploadOptions.uploadImgParamsWithUrl;
    this.editor.customConfig.uploadImgTimeout = this.uploadOptions.uploadImgTimeout;
    this.editor.customConfig.withCredentials = this.uploadOptions.withCredentials;
    this.editor.customConfig.customAlert = this.uploadOptions.customAlert;
    this.editor.customConfig.onchangeTimeout = this.changeInterval;
    // createè¿ä¸ªæ¹æ³ä¸å®è¦å¨ææéç½®é¡¹ä¹åè°ç¨
    this.editor.create();
    // å¦ææ¬å°æå­å¨å è½½æ¬å°å­å¨åå®¹
    let html = localStorage[`editorCache_${this.cacheId}`];
    if (html) this.editor.txt.html(html);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && !changes.value.isFirstChange) {
      this.editor.txt.html(changes.value.currentValue);
    }
  }

  createNotification(type: string, title: string, content: string): void {
    this.notification.create(type, title, content);
  }


}
